import { useEffect } from 'react'
import { useNativeSwipeBackStore } from '../stores/nativeSwipeBackStore'

// Disables the iOS WKWebView native edge-swipe-back gesture while `active`
// is true. Use this in:
//   - Tab-root pages (via TabWrapper): so the in-page TabSwipePager and
//     edge-swipe-open-sidebar can own horizontal swipes.
//   - Overlay-style components (drawers, modals, sheets): so swiping back
//     while they're open doesn't pop the underlying route — the overlay's
//     own JS close gesture (or close button) is the only way out.
//
// Push-style detail pages (e.g. AddManual, item-detail-direct, settings
// subpages) should NOT call this — they should let native back-swipe own
// the gesture for true iOS-feel page-pop animation with prev-screen preview.
//
// `key` must be unique per call site (e.g. 'view-item-drawer',
// 'tab-root'). Multiple callers stack via the underlying ref-counted store.
export const useDisableNativeSwipeBack = (active: boolean, key: string): void => {
  const disable = useNativeSwipeBackStore((s) => s.disable)
  const enable = useNativeSwipeBackStore((s) => s.enable)

  useEffect(() => {
    if (!active) return
    disable(key)
    return () => {
      enable(key)
    }
  }, [active, key, disable, enable])
}
